var exports = {
  "k": "xe533113f--37aba3--container",
};

module.exports = exports;
